import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {import('modules/statistics/types').InterventionCountReducer} */
const initialState = {
  count: 0,
  workCount: 0,
};

/**
 * @param {import('modules/statistics/types').InterventionCountReducer} _
 * @param {import('modules/statistics/types').FetchInterventionCountSuccessAction} action
 * @returns {import('modules/statistics/types').InterventionCountReducer}
 */
const updateAllData = (_, { payload }) => payload;

export default createReducer(initialState, {
  [types.FETCH_STATISTICS_INTERVENTION_COUNT_SUCCESS]: updateAllData,
});
